import React from "react";
import s from "./SectionStartModal.module.scss";
import Modal from "../../common/Modal";
import Button from "../../common/Button";
import {AppState} from "../../../redux/rootReducer";
import {appRoutePaths} from "../../../config/config";
import {useAppSelector} from "../../../redux/hooks";
import {lessonPlayerStore} from "../../../redux/lesson/LessonPlayerStore";

export interface ISectionStartModalProps {
  sectionNumber: number;
  sectionTitle: string;
  sectionDescription: string;
}

export default function SectionStartModal({sectionNumber, sectionTitle, sectionDescription,}: ISectionStartModalProps) {
  const shouldDisplaySectionStartModal = useAppSelector(lessonPlayerStore.getDisplaySectionStartModal);
  const updateShowStartModal = (showModal: boolean) => lessonPlayerStore.setDisplaySectionStartModal(showModal);

  if(!shouldDisplaySectionStartModal) {
    return null;
  }

  return (
    <Modal>
      <div className={s.sectionStartModal}>
        <div className={s.sectionInformation}>
          <span className={s.sectionNumber}>{sectionNumber}</span>
          <h1 className={s.sectionTitle}>{sectionTitle}</h1>
          <p className={s.sectionDescription}>{sectionDescription}</p>
        </div>
        <div className={s.actionButtons}>
          <Button
            buttonType={'secondary'}
            additionalClassName={s.outlineButton}
            text={'Go to Bootcamp'}
            navigationNote={'C'}
            onClick={() => {
              navigate(updateShowStartModal, appRoutePaths.bootCampPage);
            }}
          />
          <Button
            buttonType={'primary'}
            text={'Start Section'}
            navigationNote={'D'}
            onClick={()=>updateShowStartModal(false)}
          />
        </div>
      </div>
    </Modal>
  );
}

/** @deprecated use the useNavigate hook instead of using window.location.hash directly */
function navigate(displaySectionStartModalChanged: (d: boolean)=> void, link: string){
  displaySectionStartModalChanged(false);
  window.location.hash = link;
}

function mapStateToProps(_state: AppState, ){
  return {};
}

